import { DiffMiniLine } from "@/v2-backoffice-client/components/diff"

export type TranslationFallbackMiniDiffCellProps = {
  code: string
  db: string
}

// Compact two-line mini diff for a table cell: − code / + DB, one truncated
// line each. The expanded row (TranslationFallbackDiffField) shows the full
// word-level diff.
function TranslationFallbackMiniDiffCell(
  props: TranslationFallbackMiniDiffCellProps,
) {
  const { code, db } = props
  if (code === db) {
    return (
      <span className="block truncate text-muted-foreground" title={code}>
        {code || "—"}
      </span>
    )
  }
  return (
    <span className="flex min-w-0 flex-col gap-0.5">
      <DiffMiniLine side="old" text={code} />
      <DiffMiniLine side="new" text={db} />
    </span>
  )
}

export default TranslationFallbackMiniDiffCell
